<script>
import columns from '@/pages/giftCard/cards/columns';
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import { mapActions, mapGetters } from 'vuex';
import CreateNewGiftCard from '@/components/modals/Create-new-gift-card.vue';
import EditGiftCard from '@/components/modals/Edit-gift-card.vue';
import bem from '@/utils/bem';

const b = bem('cards-tab-page');
export default {
  data() {
    return {
      title: 'Gift Cards',
      type: 'gift_card',
      columns: columns(),
      showCreate: false,
      showEdit: false,
      selectedId: null,
    };
  },
  components: {
    CreateNewGiftCard,
    PageHeader,
    EditGiftCard,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getProductsAction: 'products/getProducts',
      deleteProductAction: 'products/deleteProduct',
    }),
    openCreateWindow() {
      this.showCreate = true;
    },
    openEditWindow(id) {
      this.selectedId = id;
      this.showEdit = true;
    },
    deleteGiftCard(id) {
      this.deleteProductAction({ id, type: this.type });
    },
  },
  mounted() {
    this.getProductsAction('gift_card');
  },
  computed: {
    ...mapGetters({
      giftCardProducts: 'products/sortedProductsByPrice',
    }),
  },
};
</script>

<template>
  <PageHeader :title="title"/>
  <div :class="b()">
    <div :class="b('create-button')">
      <a-button
        type="primary"
        html-type="button"
        @click="openCreateWindow"
      >
        Create new gift card
      </a-button>
    </div>
    <div v-if="showCreate">
      <CreateNewGiftCard v-model:show="showCreate" />
    </div>
    <div :class="b('table')">
      <a-table
        :columns="columns"
        :dataSource="giftCardProducts"
        :pagination="false"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'actions'">
            <div :class="b('action-buttons')">
              <a-button
                type="primary"
                html-type="button"
                @click="openEditWindow(record.id)"
              >
                Edit
              </a-button>
              <div v-if="showEdit && selectedId && selectedId === record.id">
                <EditGiftCard v-model:show="showEdit" :gift-card-info="record"/>
              </div>
              <a-popconfirm title="Sure to delete?" @confirm="deleteGiftCard(record.id)">
                <a-button type="primary" html-type="button" danger>
                  Delete
                </a-button>
              </a-popconfirm>
            </div>
          </template>
        </template>
      </a-table>
    </div>
  </div>
</template>

<style scoped lang="scss">
.cards-tab-page {
  margin: 0 20px;
  &__create-button {
    display: flex;
    justify-content: flex-end;
    padding: 10px 20px;
  }
  &__action-buttons {
    display: flex;
    flex-direction: row;
  }
}

button:last-child {
  margin-left: 20px;
}
</style>
